/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleHistoryManagementShowOrderResponse } from './CarpsaleHistoryManagementShowOrderResponse';

export type CarpsaleHistoryManagementShowOrderResponseApiRespoonse = {
    data?: CarpsaleHistoryManagementShowOrderResponse;
    status?: CarpsaleHistoryManagementShowOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleHistoryManagementShowOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

